import { render, staticRenderFns } from "./shopSelect.vue?vue&type=template&id=6d528ab7&scoped=true&"
import script from "./shopSelect.vue?vue&type=script&lang=js&"
export * from "./shopSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d528ab7",
  null
  
)

export default component.exports